import React, { useState, useEffect } from "react";
import Layout from '../../NewComponent/LayoutExpert/Layout';
import { getExpertRankData, getViewCountStats, getSLAComplianceData, getExpertScore, getAvgResponseTime, getDomainsByExpert, getRatingGroupsByGeo, getTotalAnsweredTrend, getExpertScoreTrend, getSlaComplianceTrend, getResponseTimeTrend } from "../../API/api";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import TooltipComp from "../../NewComponent/ToolTip/TooltipComp";
import { Grid } from "@mui/material";
import Tabs from "./Tabs";


export default function ExpertMyStats() {
	const [geoId, setGeoId] = useState({ value: 'global', id: 3 });
	const [width, setWidth] = useState(
		window.devicePixelRatio === 1.25 ? "84%" : "74%"
	  );	
	const [tab, setTabValue] = useState(1);
	const userState = useSelector((state) => state.user);
	const dispatch = useDispatch();
	const {getDataForExpertAnswersViewCount, expertRankData, viewCountStatsData, slaComplianceData, loadingDataForMyStat, getExpertScoreData, getAverageResponseTime, getDomainByExpertData, getRatingsByExpertData, getTotalAnsweredTrendDataExpert, getExpertScoreTrendData, getDataForSlaComplianceTrend, getDataForResponseTimeTrend } = bindActionCreators(Actions, dispatch);
	const [getDomainIds, setDomainIds] = useState(userState.expertTopics.map((obj) => { return obj.indexId })
	)
	const profilePicState = useSelector((state) => state.profilePage.profilePic);
	const profilePicStyles = {
		width: '50px',
		height: '50px',
		borderRadius: '25px',
		marginBottom: '15px',
		display: 'block'
	}
	const myStatState = useSelector((state) => state.myStatsData);

	const handleTabValue = (value) => {
		setTabValue(value);
	};



	useEffect(() => {
		const updateWidth = () => {
			setWidth(window.devicePixelRatio >= 1.1 ? "80%" : "74%");
		  };
		  
		  window.addEventListener("resize", updateWidth);
		loadingDataForMyStat(true);
		getExpertRankData()
		.then((res) => {
		  if (!res) return;
		  if( res.response && res.response.status === 403)
		  {
			loadingDataForMyStat(false);
		  }
		  if (res.data.data !== undefined && res.data.success) {
			expertRankData(res.data.data);
			loadingDataForMyStat(false);
		  }
		})
		.catch((err) => {
		});
		getViewCountStats().then((res) => {
			if (res === undefined) return;
			if( res.response && res.response.status === 403)
			{
			  loadingDataForMyStat(false);
			}
			if (res.data.data !== undefined || res.data.success) {
				viewCountStatsData(res.data.data);
				loadingDataForMyStat(false);
				getDataForExpertAnswersViewCount(res.data.data);
			}
		}).catch((err)=>{
			if(err.status === 403)
			{
				loadingDataForMyStat(false);
			}
		})
		getSLAComplianceData().then((res) => {
			if (res === undefined) return;
			if( res.response && res.response.status === 403)
			{
			  loadingDataForMyStat(false);
			}
			if (res.data.data !== undefined || res.data.success) {
				slaComplianceData(res.data.data);
				loadingDataForMyStat(false);
			}
		}).catch((err)=>{
			if(err.status === 403)
			{
				loadingDataForMyStat(false);
			}
		})
		getExpertScore().then((res) => {
			if (res === undefined) return;
			if( res.response && res.response.status === 403)
			{
			  loadingDataForMyStat(false);
			}
			if (res.data.data !== undefined || res.data.success) {
				getExpertScoreData(res.data.data);
				loadingDataForMyStat(false);
			}
		}).catch((err)=>{
			
		})
		getAvgResponseTime().then((res) => {
			if (res === undefined) return;
			if( res.response && res.response.status === 403)
			{
			  loadingDataForMyStat(false);
			}
			if (res.data.data !== undefined || res.data.success) {
				getAverageResponseTime(res.data.data);
				loadingDataForMyStat(false);
			}
		}).catch((err)=>{
			if(err.status === 403)
			{
				loadingDataForMyStat(false);
			}
		})
		getDomainsByExpert(geoId.id, "", true, getDomainIds.toString()).then((res) => {
			if (res === undefined) return;
			if( res.response && res.response.status === 403)
			{
			  loadingDataForMyStat(false);
			}
			if (res.data.data !== undefined || res.data.success) {
				getDomainByExpertData(res.data.data);
			}
		}).catch((err)=>{
			if(err.status === 403)
			{
				loadingDataForMyStat(false);
			}
		})
		getRatingGroupsByGeo(geoId.id, "", true, getDomainIds.toString()).then((res) => {
			if (res === undefined) return;
			if( res.response && res.response.status === 403)
			{
			  loadingDataForMyStat(false);
			}
			if (res.data.data !== undefined || res.data.success) {
				getRatingsByExpertData(res.data.data);
			}
		}).catch((err)=>{
			if(err.status === 403)
			{
				loadingDataForMyStat(false);
			}
		})
		getTotalAnsweredTrend().then((res) => {
			if (res === undefined) return;
			if( res.response && res.response.status === 403)
			{
			  loadingDataForMyStat(false);
			}
			if (res.data.success || res.data.data !== '') {
				getTotalAnsweredTrendDataExpert(res.data.data);
			}
		}).catch((err)=>{
			if(err.status === 403)
			{
				loadingDataForMyStat(false);
			}
		})
		getExpertScoreTrend().then((res) => {
			if (res === undefined) return;
			if( res.response && res.response.status === 403)
			{
			  loadingDataForMyStat(false);
			}
			if (res.data.data !== undefined || res.data.success) {
				getExpertScoreTrendData(res.data.data)
			}
		}).catch((err)=>{
			if(err.status === 403)
			{
				loadingDataForMyStat(false);
			}
		})
		getSlaComplianceTrend().then((res) => {
			if (res === undefined) return;
			if( res.response && res.response.status === 403)
			{
			  loadingDataForMyStat(false);
			}
			if (res.data.data !== undefined || res.data.success) {
				getDataForSlaComplianceTrend(res.data.data);
			}
		}).catch((err)=>{
			if(err.status === 403)
			{
				loadingDataForMyStat(false);
			}
		})
		getResponseTimeTrend().then((res) => {
			if (res === undefined) return;
			if( res.response && res.response.status === 403)
			{
			  loadingDataForMyStat(false);
			}
			if (res.data.data !== undefined || res.data.success) {
				getDataForResponseTimeTrend(res.data.data);
			}
		}).catch((err)=>{
			if(err.status === 403)
			{
				loadingDataForMyStat(false);
			}
		})
		return () => window.removeEventListener("resize", updateWidth);
	}, [])

	return (
		<>
			<Layout>
				<div style={{ width, margin: "auto", marginTop: "1%", marginBottom: '7%' }}>
					<div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
						<img
							style={profilePicStyles}
							alt="profilePic"
							src={profilePicState || require("../../Images/cliente.png")}
						/>
					</div>
					<div style={{
						fontSize: '21px',
						color: 'rgb(42, 54, 74)',
						textAlign: 'center'
					}}>Your rank among the expert community</div>
					<div style={{ display: 'flex', justifyContent: 'center' }}>
						<span style={{ fontSize: '24px', color: 'rgb(42, 54, 74)', borderRight: '1px solid #00A5FB', paddingRight: '10px' }}>{myStatState.isLoading === false && myStatState?.expertRankData?.rank && "#"}{myStatState.isLoading === false &&myStatState?.expertRankData?.rank}{myStatState.isLoading === true && " "}{` out of ${myStatState.expertRankData.totalExperts!==undefined?myStatState.expertRankData.totalExperts:""}`}</span>
						<span style={{ paddingLeft: '10px', fontSize: '24px', color: 'rgb(42, 54, 74)', borderRight: myStatState.expertRankData.rankChangeFromLastWeek && myStatState.expertRankData.rankChangeFromLastWeek !== "0.00" ? '1px solid #00A5FB' : null , paddingRight: '10px' }}>You are in top {myStatState.isLoading === false && myStatState.expertRankData !== null && Math.trunc(myStatState.expertRankData.expertRankPercent !== undefined && myStatState.expertRankData.expertRankPercent)}{myStatState.isLoading === false && "%"}</span>
						<span style={{ paddingLeft: '10px', fontSize: '24px', color: 'rgb(42, 54, 74)',paddingRight: '5px' }}>{myStatState.expertRankData && (myStatState.expertRankData.rankChangeFromLastWeek === "0.00" || myStatState.isLoading === true) ? " " : myStatState.expertRankData.rankChangeFromLastWeek}{myStatState.expertRankData.rankChangeFromLastWeek && myStatState.expertRankData.rankChangeFromLastWeek !== "0.00" && <span>in last 7 days</span>}</span>
					</div>
					<div style={{display:'flex',justifyContent:'center'}}>
					{
							myStatState.expertRankData && myStatState.expertRankData !== '' && myStatState.expertRankData.expertBadges && myStatState.expertRankData.expertBadges !== '' &&
							myStatState.expertRankData.expertBadges.mostAnsweredBadge.map((obj) => {
								if (obj.email === userState.email && obj.level !== undefined) {
									return (
										<TooltipComp children={<span style={{ margin: '3px', fontSize: '24px' }}>
											🏅
										</span>} title='Quality Answered Badge'>
										</TooltipComp>
									)
								}
							})
						}
						{
							myStatState.expertRankData && myStatState.expertRankData !== '' && myStatState.expertRankData.expertBadges && myStatState.expertRankData.expertBadges !== '' &&
							myStatState.expertRankData.expertBadges.mostAmplifiedBadge.map((obj) => {
								if (obj.email === userState.email && obj.level !== undefined) {
									return (
										<TooltipComp children={<span style={{ margin: '3px', fontSize: '24px' }}>
											🏆
										</span>} title="Most Amplified Badge">
										</TooltipComp>
									)
								}
							}
							)
						}
						{
							myStatState.expertRankData && myStatState.expertRankData !== '' && myStatState.expertRankData.expertBadges && myStatState.expertRankData.expertBadges !== '' &&
							myStatState.expertRankData.expertBadges.mostQualityBadge.map((obj) => {
								if (obj.email === userState.email && obj.level !== undefined) {
									return (
										<TooltipComp children={<span style={{ margin: '3px', fontSize: '24px' }}>
											🌟
										</span>} title='Amplified Answered Badge'>
										</TooltipComp>
									)
								}
							})
						}
					</div>
					<Grid container style={{ backgroundColor: '#fff',borderRadius: '12px', border: '1px solid #e0e2e6', padding: '24px' }}>
					<Grid item lg={12} xl={12}>
					<Tabs onStateChange={handleTabValue} />
					</Grid>
					</Grid>
				</div>
			</Layout>
		</>
	)
}